import { render, staticRenderFns } from "./saveNavigationDialog.vue?vue&type=template&id=59a4c616"
import script from "./saveNavigationDialog.vue?vue&type=script&lang=js"
export * from "./saveNavigationDialog.vue?vue&type=script&lang=js"
import style0 from "./saveNavigationDialog.vue?vue&type=style&index=0&id=59a4c616&prod&media=screen&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports